import { Box, type DivProps, Txt } from '@stenajs-webui/core';
import type { TextInputButtonSize } from '@stenajs-webui/elements';
import type { FC, ReactNode } from 'react';
import type { ApprovalConfig } from '../common/utils/approvalInfo';
import { InformationMessageIconPopover } from './information-message/InformationMessageIconPopover';
import { PopoverBody } from './popover/PopoverBody';
import { PopoverTitle } from './popover/PopoverTitle';

export interface ApproveAlertProps extends Pick<DivProps, 'tabIndex'> {
  buttonSize?: TextInputButtonSize;
  children?: ReactNode;
  config: ApprovalConfig;
}

export const ApproveAlert: FC<ApproveAlertProps> = ({ config, tabIndex, children, buttonSize }) => {
  const { descriptionText, headerText, type } = config;

  if (type === null) {
    return null;
  }

  return (
    <InformationMessageIconPopover
      iconType={type}
      placement={'left-start'}
      buttonSize={buttonSize}
      tabIndex={tabIndex}
    >
      {({ onRequestClose }) => (
        <Box minWidth={240} maxWidth={320}>
          <PopoverTitle text={headerText} onClose={onRequestClose} />
          <PopoverBody gap>
            <Txt>{descriptionText}</Txt>
            {children}
          </PopoverBody>
        </Box>
      )}
    </InformationMessageIconPopover>
  );
};
